import _extends from "@babel/runtime-corejs3/helpers/extends";
import { features } from '@kdcloudjs/table';
function useRowDrag(pipeline, rowDrag, estimatedRowHeight) {
  if (rowDrag) {
    pipeline.use(features.rowDrag(_extends({
      rowHeight: estimatedRowHeight
    }, rowDrag)));
  }
}
export default useRowDrag;